import React from 'react'

import TextArea from '../Fields/TextArea'

const ModuleThirtyThree = (props) => {
	return (
		<div>
			<h3>PROCEDURE</h3>
			<TextArea
				controlFunc={props.addToForm}
				inputType={"text"}
				name={"procedure"} 
				value={props.consentForm.procedure}
			/>
		</div>
	)
}

export default ModuleThirtyThree


// WEBPACK FOOTER //
// ./src/components/Modules/33.js